export const VerticalHoverLinePlugin = {
  id: 'vertical-hover-line',
  afterDraw: (chart) => {
    const { ctx, tooltip, scales } = chart;

    /* eslint-disable no-underscore-dangle */
    if (tooltip._active && tooltip._active.length) {
      const activePoint = tooltip._active[0];
      const { x } = activePoint.element;
      const topY = scales.y.top;
      const bottomY = scales.y.bottom;
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(x, topY);
      ctx.lineTo(x, bottomY);
      ctx.lineWidth = 1;
      ctx.strokeStyle = 'white';
      ctx.setLineDash([5, 5]);
      ctx.stroke();
      ctx.restore();
    }
    /* eslint-enable no-underscore-dangle */
  },
};
